export default __webpack_public_path__ + "static/media/production.2ba41a5a.gif";